import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useNotification } from '../../../../../../hooks'

export function useInvoiceModalFileUpload({ onDocumentIdChange }) {
  const { t } = useTranslation()

  const { handleAddErrorNotification } = useNotification()

  const [isUploading, setUploading] = useState(false)

  function handleStartUpload() {
    setUploading(true)
  }

  function handleFinishUpload(acceptedFiles, errorFiles) {
    setUploading(false)

    const uploadedFile = acceptedFiles?.[0]

    if (uploadedFile?.id) {
      onDocumentIdChange(uploadedFile.id)
    }

    if (errorFiles?.length > 0) {
      handleAddErrorNotification({
        title: t('Notification.FileErrorUploadKey', {
          count: errorFiles.length,
          totalCount: (acceptedFiles?.length ?? 0) + errorFiles.length,
        }),
      })
    }
  }

  return {
    handleFinishUpload,
    handleStartUpload,
    isUploading,
  }
}
